import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import type { EvidenciaOS, PaginatedResponse } from '../types'

interface EvidenciaListParams {
  ordem_servico?: string
  resposta_item?: string
}

export function useEvidenciaList(params?: EvidenciaListParams) {
  return useQuery({
    queryKey: ['evidencias', params],
    queryFn: async () => {
      const r = await api.get<PaginatedResponse<EvidenciaOS>>('/evidencias/', { params })
      return r.data
    },
    enabled: !!(params?.ordem_servico || params?.resposta_item),
  })
}

interface UploadEvidenciaArgs {
  ordemServicoId: string
  arquivo: File
  tipo?: 'foto' | 'documento' | 'laudo' | 'outro'
  descricao?: string
  respostaItemId?: string
}

export function useEvidenciaUpload() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({
      ordemServicoId,
      arquivo,
      tipo = 'foto',
      descricao = '',
      respostaItemId,
    }: UploadEvidenciaArgs) => {
      const fd = new FormData()
      fd.append('ordem_servico', ordemServicoId)
      fd.append('arquivo', arquivo)
      fd.append('tipo', tipo)
      if (descricao) fd.append('descricao', descricao)
      if (respostaItemId) fd.append('resposta_item', respostaItemId)
      const r = await api.post<EvidenciaOS>('/evidencias/', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      return r.data
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['evidencias'] }),
  })
}

export function useEvidenciaDelete() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => api.delete(`/evidencias/${id}/`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['evidencias'] }),
  })
}
